import type {
    RemoveCommerceCartCouponRequest,
    RemoveCommerceCartCouponResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const removeCommerceCartCouponOperation = defineCommerceOperation<
    RemoveCommerceCartCouponRequest,
    RemoveCommerceCartCouponResponse
>("commerce.cart.coupons.remove");
